import { addFilter } from '@wordpress/hooks'
import CreatePayment from './CreatePayment';

addFilter( 'wptravel_booking_button_payment_express_checkout', 'wp-travel', ( content, val ) => {
    return <CreatePayment />;
})